export const DISPUTE_TYPE_SCHOOL = {
    type: 'School',
    deletable: false,
    category: 'Dispute Type',
    description: 'Issues/disputes occurring in a school setting, except for disputes amongst staff',
    value: [
        {
            _id: '507f1f77bcf86cd799439048',
            label: 'Bullying/Harassment',
            description: 'In-person or online bullying and/or harrasment between two or more youth',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439062',
            label: 'Discrimination',
            description:
                'Unjust or prejudicial treatment of a student, teacher, or other member or the school community',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439049',
            label: 'Friendship',
            description: 'Interpersonal issues between friends, friend groups, or former friends',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439050',
            label: 'LGBTQ+',
            description:
                'Conflicts affecting one or more person(s) who identifies with the LGBTQ+ community related to LGBTQ+ issues',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439051',
            label: 'Misunderstanding',
            description: 'Issues that arise from communication challenges or misunderstandings',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439052',
            label: 'Name-Call/Tease',
            description: 'Conflicts the arise from name-calling or teasing',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439053',
            label: 'Physical Fight',
            description: 'Conflicts that resulted in a physical altercation',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439054',
            label: 'Race-Related',
            description: 'Any issues arising from racial discrimination or conflicts involving race',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439055',
            label: 'Romantic Relationship',
            description: 'Conflicts that arise around romantic relationships',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439056',
            label: 'Rumors',
            description: 'Conflicts resulting from rumors',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439057',
            label: 'Social Media',
            description:
                'Conflict stemming from or occuring on a social media platform such as bullying/harrasment, name-calling, or discrimination',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439058',
            label: 'Special Ed',
            description:
                'Conflicts occuring within the context of students or staff within the special education program at school',
            active: true,
        },

        {
            _id: '507f1f77bcf86cd799439061',
            label: 'Staff/Parent',
            description: 'Conflict between a parent(s)/caregiver(s) and a student(s)',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439059',
            label: 'Staff/Student',
            description: 'Conflict between a staff member(s) and a student(s)',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439060',
            label: 'Threats',
            description: 'Verbal or written statements articulating an intent to cause or inflict harm',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439063',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_BUSINESS = {
    type: 'Business',
    deletable: false,
    category: 'Dispute Type',
    description: 'Issues/disputes relating to all business sales and services',
    value: [
        {
            _id: '507f1f77bcf86cd799439017',
            active: true,
            label: 'Auto',
            description: 'All auto related issues including auto sales, repair, accidents',
        },
        {
            _id: '507f1f77bcf86cd799439018',
            active: true,
            label: 'Services',
            description:
                'All business services including contracts for services, professional services, medical services, phone, cable, and internet services',
        },
        {
            _id: '507f1f77bcf86cd799439019',
            active: true,
            label: 'Debt Collection',
            description: 'Unpaid bills, does not include a dispute about the service or product',
        },
        {
            _id: '507f1f77bcf86cd799439020',
            active: true,
            label: 'Financial Institution',
            description: 'Banks, Lenders, creditors, etc.',
        },
        {
            _id: '507f1f77bcf86cd799439021',
            active: true,
            label: 'Home Repair/ Issues',
            description: 'Contractor disputes, quality of services, plumbing, electrical, landscaping, painting',
        },
        {
            _id: '507f1f77bcf86cd799439022',
            active: true,
            label: 'Property Damage',
            description: 'Damage to personal and real property, for example cell phones, boats, windows, fences',
        },
        {
            _id: '507f1f77bcf86cd799439023',
            active: true,
            label: 'Real Estate/Home/Condo',
            description: 'Sales, security deposit disputes, HOA, home inspections',
        },
        {
            _id: '507f1f77bcf86cd799439024',
            active: true,
            label: 'Utility',
            description: 'All utilities - gas, electric, water, sewer, trash',
        },
        {
            _id: '507f1f77bcf86cd799439025',
            active: true,
            label: 'Other',
        },
    ],
};

export const DISPUTE_TYPE_FAMILY = {
    type: 'Family',
    deletable: false,
    category: 'Dispute Type',
    description: 'Issues/disputes relating to family matters',
    value: [
        {
            _id: '507f1f77bcf86cd799439026',
            label: 'Alt Divorce',
            description: 'Issues/disputes relating to all family matters within the context of a not-married couple',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439027',
            label: 'Alt Post-Divorce',
            description:
                'Issues/disputes relating to all family matters within the context of a not-married, now separated couple',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439028',
            label: 'Divorce',
            description: 'Filing for divorce',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439029',
            label: 'Elder',
            description: 'Elder care-taking issues or decision making, neglect, etc.',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439030',
            label: 'Estate/Bus/Finance',
            description: 'Family discussions regarding estate planning, family business or finances',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439031',
            label: 'Parent/Child',
            description: 'Parent child relationships',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439032',
            label: 'Parenting Plan',
            description:
                'Parents (bio, adoptive, guardians, etc.) discussing parenting arrangements around children (could include both physical and legal custody matters)',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439033',
            label: 'Post-Divorce',
            description: 'Issues arising after divorce is complete',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439034',
            label: 'Visitation',
            description: 'Court ordered',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439035',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_GOVERNMENT = {
    type: 'Government',
    deletable: false,
    category: 'Dispute Type',
    description: 'Issues/topics arising from governmental policies or decisions',
    value: [
        {
            _id: '507f1f77bcf86cd799439036',
            label: 'Public Policy',
            description: 'Issues or topics relating to social issues influenced by governmental policies',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439037',
            label: 'Municipal',
            description: 'Relating to a city or town or its governing body',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439038',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_HOSING = {
    type: 'Housing',
    deletable: false,
    category: 'Dispute Type',
    description: `Issues/disputes relating to people's residences`,
    value: [
        {
            _id: '507f1f77bcf86cd799439039',
            label: 'Landlord/Tenant',
            description: 'Evictions, rent related, access, living conditions, interpersonal issues',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439040',
            label: 'Room/Housemate',
            description: 'Interpersonal issues (within the same unit)',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439041',
            label: 'Neighbor Issues',
            description: 'Any conflict between neighbors (noise, property, interpersonal)',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439042',
            label: 'Discrimination',
            description: 'Issues around unjust or prejudicial treatment related to housing',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439043',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_NEIGHBORHOOD = {
    type: 'Neighborhood',
    deletable: false,
    category: 'Dispute Type',
    description: `Issues/disputes relation to people's residential area`,
    value: [
        {
            _id: '507f1f77bcf86cd799439044',
            label: 'Property/Land Use',
            description: 'Issues around use of property or land in the neighborhood',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439045',
            label: 'Animals/Pets',
            description: 'Issues around animals/pets impacting the neighborhood',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439046',
            label: 'Human Rights',
            description: 'Topics around basic rights and freedoms for individuals',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439047',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_WORKPLACE = {
    type: 'Workplace',
    deletable: false,
    category: 'Dispute Type',
    description:
        'Issues/disputes occurring in a workplace including (but not limited to) schools, businesses, religious organizations, non-profits',
    value: [
        {
            _id: '507f1f77bcf86cd799439064',
            label: 'Co-worker/Peer',
            description: 'Interpersonal issues between co-workers',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439065',
            label: 'Supervisor/Supervisee',
            description: 'Interpersonal issues between manager and employee',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439066',
            label: 'Organizational',
            description: 'Issues affecting the broader organization',
            active: true,
        },
        {
            _id: '507f1f77bcf86cd799439067',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPE_OTHER = {
    type: 'Other',
    deletable: false,
    category: 'Dispute Type',
    value: [
        {
            _id: '507f1f77bcf86cd799239063',
            label: 'Other',
            description: '',
            active: true,
        },
    ],
};

export const DISPUTE_TYPES = [
    DISPUTE_TYPE_BUSINESS,
    DISPUTE_TYPE_FAMILY,
    DISPUTE_TYPE_GOVERNMENT,
    DISPUTE_TYPE_HOSING,
    DISPUTE_TYPE_NEIGHBORHOOD,
    DISPUTE_TYPE_SCHOOL,
    DISPUTE_TYPE_WORKPLACE,
    DISPUTE_TYPE_OTHER,
];
